import React, { ReactNode } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

interface HighlightProps {
  children: ReactNode;
}

const HighlightItem = styled.span`
  position: relative;
`;

const HighlightText = styled.span<{ isFirst?: boolean }>`
  position: relative;
  z-index: 1;
  font-weight: bold;

  padding-right: ${(props) => (props.isFirst ? 10 : 0)}px;
`;


export const Highlight = ({ children }: HighlightProps): any =>
  (children as string).split(' ').map((word, index, words) => (
    <HighlightItem key={index}>
      <HighlightText isFirst={words.length > 1 && index === 0}>{word}</HighlightText>
    </HighlightItem>
  ));
